// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 97.51 78.15\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#f6993e\" d=\"M34.09 9.71a.49.49 0 01.2.09 48.4 48.4 0 01.06 68.36L0 43.8z\"/><path fill=\"#00363d\" d=\"M73.13 48.83a.62.62 0 00-.09-.16A34.41 34.41 0 0173.06 0l24.45 24.45z\"/></g></svg>";
// Exports
module.exports = code;